<template>
    <v-container fluid class="pa-0">
        <!-- loading status -->
        <v-row class="ma-0 pa-0">
            <v-progress-linear
                v-if="$apollo.queries.myTenantDashboard.loading"
                color="primary"
                indeterminate
                rounded
                class="ma-0 pa-0"
            ></v-progress-linear>
        </v-row>
        <v-container>
            <v-row align="center" class="mt-10">
                <!-- plants -->
                <v-col
                    v-if="hasPermission('view_plant')"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                :loading="
                                    $apollo.queries.myTenantDashboard.loading
                                        ? 'white'
                                        : null
                                "
                                :elevation="hover ? 10 : 1"
                                color="primary lighten-1"
                                dark
                                outlined
                                height="160px"
                                link
                                href="/#/plants"
                            >
                                <v-card-title class="subtitle-1"
                                    >Plants</v-card-title
                                >

                                <v-card-text>
                                    <v-row align="center">
                                        <v-col cols="2">
                                            <v-icon large>eco</v-icon>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            class="display-3 text-right"
                                            >{{
                                                myTenantDashboard.totalPlants
                                            }}</v-col
                                        >
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>

                <!-- products -->
                <v-col
                    v-if="hasPermission('view_product')"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                :loading="
                                    $apollo.queries.myTenantDashboard.loading
                                        ? 'white'
                                        : null
                                "
                                :elevation="hover ? 10 : 1"
                                color="primary lighten-1"
                                dark
                                outlined
                                height="160px"
                                link
                                href="/#/products"
                            >
                                <v-card-title class="subtitle-1"
                                    >Products
                                    <v-spacer></v-spacer>
                                    <span v-if="unconfigProductsCount > 0">
                                        <v-chip
                                            small
                                            class="px-3 mr-2"
                                            color="red lighten-1"
                                        >
                                            {{ unconfigProductsCount }}</v-chip
                                        >
                                    </span></v-card-title
                                >

                                <v-card-text>
                                    <v-row align="center">
                                        <v-col cols="2">
                                            <v-icon large>local_offer</v-icon>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            class="display-3 text-right"
                                            >{{
                                                myTenantDashboard.totalProducts
                                            }}</v-col
                                        >
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>

                <!-- orders -->
                <v-col
                    v-if="hasPermission('view_salesorder')"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                :loading="
                                    $apollo.queries.myTenantDashboard.loading
                                        ? 'white'
                                        : null
                                "
                                :elevation="hover ? 10 : 1"
                                color="primary lighten-1"
                                dark
                                outlined
                                height="160px"
                                link
                                href="/#/orders"
                            >
                                <v-card-title class="subtitle-1"
                                    >Orders
                                    <v-spacer></v-spacer>
                                    <span v-if="pendingOrdersCount > 0">
                                        <v-chip
                                            small
                                            class="px-3 mr-2"
                                            color="warning lighten-1"
                                            >{{ pendingOrdersCount }}</v-chip
                                        >
                                    </span>
                                </v-card-title>

                                <v-card-text>
                                    <v-row align="center">
                                        <v-col cols="2">
                                            <v-icon large>receipt</v-icon>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            class="display-3 text-right"
                                            >{{
                                                myTenantDashboard.totalOrders
                                            }}</v-col
                                        >
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>

                <!-- greenhouses -->
                <v-col
                    v-if="hasPermission('view_greenhouse')"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                :loading="
                                    $apollo.queries.myTenantDashboard.loading
                                        ? 'white'
                                        : null
                                "
                                :elevation="hover ? 10 : 1"
                                color="primary lighten-1"
                                dark
                                outlined
                                height="160px"
                                link
                                href="/#/greenhouses"
                            >
                                <v-card-title class="subtitle-1"
                                    >Greenhouses</v-card-title
                                >

                                <v-card-text>
                                    <v-row align="center">
                                        <v-col cols="2">
                                            <v-icon large>view_quilt</v-icon>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            class="display-3 text-right"
                                            >{{
                                                totalGreenhouseUsedRateP
                                            }}%</v-col
                                        >
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>

                <!-- growth tasks -->
                <v-col
                    v-if="hasPermission('view_growthtask')"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                :loading="
                                    $apollo.queries.myTenantDashboard.loading
                                        ? 'white'
                                        : null
                                "
                                :elevation="hover ? 10 : 1"
                                color="primary lighten-1"
                                dark
                                outlined
                                height="160px"
                                link
                                href="/#/growthtasks"
                            >
                                <v-card-title class="subtitle-1"
                                    >Growth Tasks
                                    <v-spacer></v-spacer>
                                    <span v-if="growthTaskActionsCount > 0">
                                        <v-chip
                                            small
                                            class="px-3 mr-2"
                                            color="red lighten-1"
                                        >
                                            {{ growthTaskActionsCount }}</v-chip
                                        >
                                    </span></v-card-title
                                >

                                <v-card-text>
                                    <v-row align="center">
                                        <v-col cols="2">
                                            <v-icon large>date_range</v-icon>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            class="display-3 text-right"
                                            >{{
                                                myTenantDashboard.totalGrowthTasks
                                            }}</v-col
                                        >
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>

                <!-- Inventory -->
                <v-col
                    v-if="hasPermission('view_growthtaskinventorybyplant')"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                :loading="
                                    $apollo.queries.myTenantDashboard.loading
                                        ? 'white'
                                        : null
                                "
                                :elevation="hover ? 10 : 1"
                                color="primary lighten-1"
                                dark
                                outlined
                                height="160px"
                                link
                                href="/#/inventory"
                            >
                                <v-card-title class="subtitle-1"
                                    >Inventory</v-card-title
                                >
                                <v-card-text>
                                    <v-row align="center">
                                        <v-col cols="2">
                                            <v-icon large>storefront</v-icon>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            :class="bigNumberDisplayClass"
                                        >
                                            {{
                                                myTenantDashboard.totalInventory
                                            }}
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>
                <!-- Cost Rates -->
                <v-col
                    v-if="hasPermission('view_plannedtask')"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                :loading="
                                    $apollo.queries.myTenantDashboard.loading
                                        ? 'white'
                                        : null
                                "
                                :elevation="hover ? 10 : 1"
                                color="primary lighten-1"
                                dark
                                outlined
                                height="160px"
                                link
                                href="/#/costrates"
                            >
                                <v-card-title class="subtitle-1"
                                    >Cost Rates</v-card-title
                                >

                                <v-card-text>
                                    <v-row align="center">
                                        <v-col cols="2">
                                            <v-icon large>euro_symbol</v-icon>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            class="display-3 text-right"
                                            >{{
                                                $apollo.queries
                                                    .myTenantDashboard.loading
                                                    ? 0
                                                    : 3
                                            }}
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>

                <!-- Planning Tool -->
                <v-col
                    v-if="hasPermission('view_plannedtask')"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                :loading="
                                    $apollo.queries.myTenantDashboard.loading
                                        ? 'white'
                                        : null
                                "
                                :elevation="hover ? 10 : 1"
                                color="primary lighten-1"
                                dark
                                outlined
                                height="160px"
                                link
                                href="/#/planningtool"
                            >
                                <v-card-title class="subtitle-1"
                                    >Planning Tool</v-card-title
                                >

                                <v-card-text>
                                    <v-row align="center">
                                        <v-col cols="2">
                                            <v-icon large>content_paste</v-icon>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            class="display-3 text-right"
                                            >{{
                                                myTenantDashboard.totalPlannedTasks
                                            }}</v-col
                                        >
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>

                <!-- P & L -->
                <v-col
                    v-if="hasPermission('view_plannedtask')"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                :loading="
                                    $apollo.queries.myTenantDashboard.loading
                                        ? 'white'
                                        : null
                                "
                                :elevation="hover ? 10 : 1"
                                color="primary lighten-1"
                                dark
                                outlined
                                height="160px"
                                link
                                href="/#/pl"
                            >
                                <v-card-title class="subtitle-1"
                                    >P & L</v-card-title
                                >

                                <v-card-text>
                                    <v-row align="center">
                                        <v-col cols="2">
                                            <v-icon large
                                                >account_balance</v-icon
                                            >
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            class="display-3 text-right"
                                            >{{
                                                $apollo.queries
                                                    .myTenantDashboard.loading
                                                    ? 0
                                                    : 1
                                            }}
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>

                <!-- Customers -->
                <v-col
                    v-if="hasPermission('view_customer')"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                :loading="
                                    $apollo.queries.myTenantDashboard.loading
                                        ? 'white'
                                        : null
                                "
                                :elevation="hover ? 10 : 1"
                                color="primary lighten-1"
                                dark
                                outlined
                                height="160px"
                                link
                                href="/#/customers"
                            >
                                <v-card-title class="subtitle-1"
                                    >Customers</v-card-title
                                >

                                <v-card-text>
                                    <v-row align="center">
                                        <v-col cols="2">
                                            <v-icon large>group</v-icon>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            class="display-3 text-right"
                                            >{{
                                                myTenantDashboard.totalCustomers
                                            }}</v-col
                                        >
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>

                <!-- Suppliers -->
                <v-col
                    v-if="hasPermission('view_supplier')"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                :loading="
                                    $apollo.queries.myTenantDashboard.loading
                                        ? 'white'
                                        : null
                                "
                                :elevation="hover ? 10 : 1"
                                color="primary lighten-1"
                                dark
                                outlined
                                height="160px"
                                link
                                href="/#/suppliers"
                            >
                                <v-card-title class="subtitle-1"
                                    >Suppliers</v-card-title
                                >

                                <v-card-text>
                                    <v-row align="center">
                                        <v-col cols="2">
                                            <v-icon large>spa</v-icon>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            class="display-3 text-right"
                                            >{{
                                                myTenantDashboard.totalSuppliers
                                            }}</v-col
                                        >
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>

                <!-- Groups -->
                <v-col
                    v-if="hasPermission('view_tenantusergroup')"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                :loading="
                                    $apollo.queries.myTenantDashboard.loading
                                        ? 'white'
                                        : null
                                "
                                :elevation="hover ? 10 : 1"
                                color="primary lighten-1"
                                dark
                                outlined
                                height="160px"
                                link
                                href="/#/groups"
                            >
                                <v-card-title class="subtitle-1"
                                    >Groups</v-card-title
                                >

                                <v-card-text>
                                    <v-row align="center">
                                        <v-col cols="2">
                                            <v-icon large
                                                >people_outline</v-icon
                                            >
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            class="display-3 text-right"
                                            >{{
                                                myTenantDashboard.totalGroups
                                            }}</v-col
                                        >
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>

                <!-- Users -->
                <v-col
                    v-if="hasPermission('view_customuser')"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                :loading="
                                    $apollo.queries.myTenantDashboard.loading
                                        ? 'white'
                                        : null
                                "
                                :elevation="hover ? 10 : 1"
                                color="primary lighten-1"
                                dark
                                outlined
                                height="160px"
                                link
                                href="/#/users"
                            >
                                <v-card-title class="subtitle-1"
                                    >Users</v-card-title
                                >

                                <v-card-text>
                                    <v-row align="center">
                                        <v-col cols="2">
                                            <v-icon large>contacts</v-icon>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            class="display-3 text-right"
                                            >{{
                                                myTenantDashboard.totalUsers
                                            }}</v-col
                                        >
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>

                <!-- Customized Modules -->
                <v-col
                    v-for="m in customizedModules"
                    :key="m.title"
                    cols="12"
                    sm="6"
                    md="4"
                >
                    <v-hover>
                        <template v-slot="{ hover }">
                            <v-card
                                :loading="
                                    $apollo.queries.myTenantDashboard.loading
                                        ? 'white'
                                        : null
                                "
                                :elevation="hover ? 10 : 1"
                                color="primary lighten-1"
                                dark
                                outlined
                                height="160px"
                                link
                                @click="goToUrl(m.url)"
                            >
                                <v-card-title class="subtitle-1">{{
                                    m.title
                                }}</v-card-title>

                                <v-card-text>
                                    <v-row align="center">
                                        <v-col cols="2">
                                            <v-icon large>{{ m.icon }}</v-icon>
                                        </v-col>
                                        <v-col
                                            cols="10"
                                            class="display-2 text-right font-weight-light"
                                            >△</v-col
                                        >
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-hover>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import helper from "@/utils/helper.js";

export default {
    apollo: {
        myTenantDashboard: {
            query: gql`
                query myTenantDashboard(
                    $currentGrowthTaskPhase_EndDate_Lt: Date
                ) {
                    myTenantDashboard {
                        id
                        tenant {
                            id
                            name
                        }
                        totalPlants
                        totalProducts
                        totalGrowthTasks
                        totalInventory
                        totalOrders
                        totalPicklists
                        totalGreenhouseSpaceM2
                        totalGreenhouseUsedSpaceM2
                        totalGreenhouseUsedRate
                        totalSuppliers
                        totalCustomers
                        totalGroups
                        totalUsers
                        totalPlannedTasks
                    }
                    tenantProducts(
                        isPlantsConfigured_Iexact: false
                        isIgnored_Iexact: false
                    ) {
                        totalCount
                    }
                    tenantSalesOrders(orderStatus_Iexact: "PENDING") {
                        totalCount
                    }
                    tenantGrowthTasks(
                        totalInventory_Gt: 0
                        isReadyToSell: false
                        currentGrowthTaskPhase_EndDate_Lt: $currentGrowthTaskPhase_EndDate_Lt
                    ) {
                        totalCount
                    }
                }
            `,
            variables() {
                return {
                    // orderStatus_In: this.orderStatusFilter
                    currentGrowthTaskPhase_EndDate_Lt: moment(
                        this.today
                    ).format("YYYY-MM-DD")
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            // update: (data) => {
            //     // console.log(data);
            //     // if (data) {
            //     //     this.myTenantDashboard = data.myTenantDashboard;
            //     // }
            //     this.unconfigProductsCount = data.tenantProducts.totalCount;
            //     return data.myTenantDashboard;
            // },
            manual: true,
            result({ data, loading }) {
                if (!loading) {
                    this.myTenantDashboard = data.myTenantDashboard;
                    this.unconfigProductsCount = data.tenantProducts.totalCount;
                    this.growthTaskActionsCount =
                        data.tenantGrowthTasks.totalCount;
                    this.pendingOrdersCount = data.tenantSalesOrders.totalCount;
                }
            },
            skip: false,
            pollInterval: 60000 // ms
        }
    },

    data() {
        return {
            myTenantDashboard: {
                totalPlants: 0,
                totalProducts: 0,
                totalGrowthTasks: 0,
                totalInventory: 0,
                totalOrders: 0,
                totalGreenhouseSpaceM2: 0,
                totalGreenhouseUsedSpaceM2: 0,
                totalGreenhouseUsedRate: 0,
                totalSuppliers: 0,
                totalCustomers: 0,
                totalGroups: 0,
                totalUsers: 0,
                totalPlannedTasks: 0
            },
            unconfigProductsCount: 0,
            growthTaskActionsCount: 0,
            pendingOrdersCount: 0
            // $apollo.queries.myTenantDashboard.loading: false

            // items: [
            //     {
            //         id: "plants",
            //         icon: "eco",
            //         title: "Plants",
            //         url: "/#/plants",
            //         data: 0
            //     },
            //     {
            //         id: "products",
            //         icon: "local_offer",
            //         title: "Products",
            //         url: "/#/products",
            //         data: 0
            //     },
            //     {
            //         id: "orders",
            //         icon: "receipt",
            //         title: "Orders",
            //         url: "/#/orders",
            //         data: 0
            //     },
            //     {
            //         id: "greenhouses",
            //         icon: "view_quilt",
            //         title: "Greenhouses",
            //         url: "/#/greenhouses",
            //         data: "0%"
            //     },
            //     {
            //         id: "growthtasks",
            //         icon: "date_range",
            //         title: "Growth Tasks",
            //         url: "/#/growthtasks",
            //         data: 0
            //     },
            //     {
            //         id: "inventory",
            //         icon: "storefront",
            //         title: "Inventory",
            //         url: "/#/inventory",
            //         data: 0
            //     }
            // ]
        };
    },
    computed: {
        today() {
            var _today = new Date();
            _today.setHours(23, 59, 59, 59); // remove time

            return _today;
        },
        totalGreenhouseUsedRateP() {
            return Math.round(
                this.myTenantDashboard.totalGreenhouseUsedRate * 100
            );
        },
        me() {
            return this.$store.state.user.me;
        },
        customizedModules() {
            var _customizedModules = [];
            try {
                if (this.me) {
                    _customizedModules = JSON.parse(
                        this.me.customizedModulesJson
                    );
                }
            } catch (error) {
                console.log(error);
            }
            return _customizedModules;
        },
        bigNumberDisplayClass() {
            if (
                this.myTenantDashboard.totalInventory >= 1000000 &&
                this.$vuetify.breakpoint.md
            )
                return "display-2 px-0 text-right";
            else return "display-3 text-right";
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
        // this.initialize();
    },
    methods: {
        goToUrl(url) {
            this.$router.push(url);
        }
        // initialize() {
        //     this.fetchMyTenantDashboard();
        // },
        // fetchMyTenantDashboard() {
        //     // fetch growth tasks
        //     this.$apollo.queries.myTenantDashboard.loading = true;
        //     this.$store
        //         .dispatch("tenants/fetchMyTenantDashboard")
        //         .then(response => {
        //             // console.log(response);
        //             this.myTenantDashboard = JSON.parse(
        //                 JSON.stringify(response)
        //             );
        //             // let _myTenantDashboard = JSON.parse(
        //             //     JSON.stringify(response)
        //             // );
        //             // this.items.map(item => {
        //             //     switch (item.id) {
        //             //         case "plants":
        //             //             item.data = _myTenantDashboard.totalPlants;
        //             //             break;
        //             //         case "products":
        //             //             item.data = _myTenantDashboard.totalProducts;
        //             //             break;
        //             //         case "greenhouses":
        //             //             item.data =
        //             //                 ~~(
        //             //                     _myTenantDashboard.totalGreenhouseUsedRate *
        //             //                     100
        //             //                 ) + "%";
        //             //             break;
        //             //         case "growthtasks":
        //             //             item.data = _myTenantDashboard.totalGrowthTasks;
        //             //             break;
        //             //         case "inventory":
        //             //             item.data = _myTenantDashboard.totalInventory;
        //             //             break;
        //             //         case "orders":
        //             //             item.data = _myTenantDashboard.totalOrders;
        //             //             break;
        //             //         case "picklists":
        //             //             item.data = _myTenantDashboard.totalPicklists;
        //             //             break;
        //             //         default:
        //             //             null;
        //             //     }
        //             // });
        //         })
        //         .catch(error => {
        //             /*handle errors*/
        //             console.log(error);
        //         })
        //         .finally(() => (this.$apollo.queries.myTenantDashboard.loading = false));
        // }
    }
};
</script>